<template>
    <!-- Yandex.RTB R-A-13860099-2 -->

    <div :id="uniqueId"></div>
</template>

<script>
export default {
    name: "YandexAd",
    data() {
        return {
            uniqueId: `yandex_rtb_R-A-13860099-2_${Math.random()
                .toString(36)
                .substr(2, 9)}`,
        };
    },
    mounted() {
        // Инициализируем Yandex.RTB если еще не инициализирован
        if (!window.yaContextCb) {
            window.yaContextCb = [];

            // Загружаем скрипт Yandex.RTB
            const script = document.createElement("script");
            script.src = "https://yandex.ru/ads/system/context.js";
            script.async = true;
            document.head.appendChild(script);
        }

        // Рендерим рекламный блок
        window.yaContextCb.push(() => {
            Ya.Context.AdvManager.render({
                blockId: "R-A-13860099-2",
                renderTo: this.uniqueId,
            });
        });
    },
};
</script>
